import React, { useTranslation } from "react-i18next";
import one from "../../assets/Order/one.svg";
import two from "../../assets/Order/two.svg";
import three from "../../assets/Order/three.svg";
import posorders from "../../assets/Dashboard/posorders.svg";
import postotalsales from "../../assets/Dashboard/postotalsales.svg";
import totalcreditvalue from "../../assets/Dashboard/totalcreditvalue.svg";
import creditvalue from "../../assets/Dashboard/creditvalue.svg";

const VendorSummaryTiles = ({ data }) => {
  const { t } = useTranslation();

  const values = [
    {
      img: posorders,
      heading: t("Total Orders"),
      value: data?.total_orders_count,
    },
    {
      img: postotalsales,
      heading: t("Total Invoice"),
      value: `${t("EGP")} ${Number(data?.total_sum_of_invoice || 0).toFixed(2)}`,
    },
    {
      img: totalcreditvalue,
      heading: t("Paid Amount"),
      value: `${t("EGP")} ${Number(data?.total_paid_amount || 0).toFixed(2)}`,
    },
    {
      img: creditvalue,
      heading: t("Due Amount"),
      value: `${t("EGP")} ${Number(data?.total_due_amount || 0).toFixed(2)}`,
    },
  ];

  return (
    <div className="flex flex-wrap gap-4 mb-4">
      {values.map((item, index) => (
        <div
          key={index}
          className="flex-1 min-w-[220px] max-w-full"
        >
          <div
            className="
              flex items-center
              border border-gray-300
              rounded-md
              bg-white
              px-6
              py-4
              shadow-sm
              transition-all
              duration-200
              hover:bg-[#E3F2FD]
              hover:shadow-lg
            "
          >
            <div className="flex-shrink-0 me-4">
              <img
                src={item.img}
                alt={item.heading}
                width={36}
                height={36}
              />
            </div>

            <div className="flex flex-col">
              <span className="text-sm font-medium text-gray-700">
                {item.heading}
              </span>

              <span className="text-l font-bold text-gray-800">
                {item.value}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default VendorSummaryTiles;